module.exports = __webpack_public_path__ + "static/media/997708.8e7673f5.jpg";